export default __webpack_public_path__ + "static/11-335fc9816cd2a0620c93d0154aaf556b.webp";